import { getAccount } from '@lair-finance/wagmi/core'
import { wagmiConfig } from '@/app/providers/wagmi'

export const wagmiGetAccount = () => getAccount(wagmiConfig)
